import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { Button, PageEmptyState } from 'seagull';
import { Plus } from 'seagull/icons';
import { openInNewTabProps } from '~/constants';
import { useStore } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { ServiceTemplateType } from '~/models/service-template';
import { selectors } from '~/store/state-selectors';
import { helpArticles } from '~/utils/helpArticles';
import { CommonServicesPage } from '../CommonServicesPage/CommonServicesPage';
import { bulkImportRoute, ColumnId } from '../CommonServicesPage/CommonServicesPage.utils';
import { useExportCsv } from '../CommonServicesPage/useExportCsv';
import EmptyServices from '../emptyServices.svg';
export function BundlesPage() {
    const { t: bundlesPageTexts } = useLocaleKeys('pages.bundlesPage');
    const tableDefs = [
        {
            headerItem: {
                value: bundlesPageTexts.columns.bundleName(),
                id: ColumnId.Name
            },
            columnDef: {
                width: [
                    200,
                    300
                ],
                sortable: true,
                mobile: {},
                bi: {
                    name: 'sort_bundles_by_name'
                }
            },
            defaultSortDirection: 'desc'
        },
        {
            headerItem: {
                value: bundlesPageTexts.columns.includedServices(),
                id: ColumnId.IncludedServices
            },
            columnDef: {
                width: [
                    200,
                    400
                ],
                sortable: false,
                mobile: {}
            },
            defaultSortDirection: 'desc'
        },
        {
            headerItem: {
                value: bundlesPageTexts.columns.billingOccurrence(),
                id: ColumnId.BillingOccurance
            },
            columnDef: {
                width: 120,
                sortable: true,
                mobile: {},
                bi: {
                    name: 'sort_bundles_by_billing_occurrence'
                }
            },
            defaultSortDirection: 'desc'
        },
        {
            headerItem: {
                value: bundlesPageTexts.columns.billingTrigger(),
                id: ColumnId.BillingTrigger
            },
            columnDef: {
                width: 180,
                sortable: true,
                bi: {
                    name: 'sort_bundles_by_billing_trigger'
                }
            },
            defaultSortDirection: 'desc'
        }
    ];
    const baseColumnDefs = tableDefs.map((d)=>d.columnDef);
    const baseHeaderItems = tableDefs.map((d)=>d.headerItem);
    const mobileSortOptions = tableDefs.flatMap((d, colIndex)=>d.columnDef.sortable && d.columnDef.mobile ? [
            {
                id: d.headerItem.id,
                label: d.headerItem.value,
                defaultDirection: d.defaultSortDirection,
                colIndex
            }
        ] : []);
    const importServicesLink = useStore(selectors.filterAvailableRoutes([
        bulkImportRoute('bundles', bundlesPageTexts.importBundles())
    ]))[0];
    const { exportingCsv, handleExportCsv } = useExportCsv('bundle', 'bundles-', 'bundles-page-export-csv-error');
    const renderHeaderActions = (param)=>{
        let { openBuilder } = param;
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                importServicesLink && /*#__PURE__*/ _jsx(Button, {
                    bi: {
                        name: 'import_bundles'
                    },
                    skin: "primaryOutline",
                    as: Link,
                    to: importServicesLink.url,
                    children: importServicesLink.text
                }),
                /*#__PURE__*/ _jsx(Button, {
                    bi: {
                        name: 'export_bundles_csv'
                    },
                    skin: "primaryOutline",
                    testId: "bundles-page-export-csv-btn",
                    disabled: exportingCsv,
                    onClick: handleExportCsv,
                    children: bundlesPageTexts.exportCsv()
                }),
                /*#__PURE__*/ _jsx(Button, {
                    bi: {
                        name: 'create_bundle'
                    },
                    prefixIcon: /*#__PURE__*/ _jsx(Plus, {
                        size: 18
                    }),
                    testId: "bundles-page-create-btn",
                    onClick: ()=>openBuilder(),
                    children: bundlesPageTexts.createBundle()
                })
            ]
        });
    };
    const renderEmptyState = (param)=>{
        let { openBuilder } = param;
        return /*#__PURE__*/ _jsx(PageEmptyState, {
            maxHeight: true,
            testId: "bundles-empty",
            illustration: /*#__PURE__*/ _jsx(EmptyServices, {}),
            title: bundlesPageTexts.emptyTitle(),
            message: bundlesPageTexts.emptyMessage(),
            actions: /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
                        bi: {
                            name: 'learn_more_bundles'
                        }
                    }, openInNewTabProps), {
                        skin: "primaryOutline",
                        testId: "bundles-learn-more-btn",
                        as: "a",
                        href: helpArticles.bundles(),
                        children: bundlesPageTexts.learnMore()
                    })),
                    /*#__PURE__*/ _jsx(Button, {
                        bi: {
                            name: 'create_bundle_from_empty_state'
                        },
                        testId: "bundles-page-new-btn",
                        onClick: ()=>openBuilder(),
                        children: bundlesPageTexts.createBundle()
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ _jsx(CommonServicesPage, {
        title: bundlesPageTexts.title(),
        columnDefs: baseColumnDefs,
        headerItems: baseHeaderItems,
        templateType: ServiceTemplateType.Bundle,
        renderEmptyState: renderEmptyState,
        headerActions: renderHeaderActions,
        mobileSortOptions: mobileSortOptions,
        bundlesMode: true
    });
}
